export default __webpack_public_path__ + "static/media/placeholder-image.6c3ce80f.jpg";